import { Col, Form, Row, Typography } from "antd";
import QuillEditor from "components/Editor";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import Card from "features/Cart/components/Card";
import { t } from "i18next";

const discountRateField = {
  type: INPUT_TYPE.NUMBER,
  formItemOptions: {
    label: <Typography.Text strong>Mức chiết khấu (%)</Typography.Text>,
    name: "discountRate",
    validateTrigger: ["onChange", "onBlur"],
    rules: [
      {
        required: true,
        message: t("common.messageRequiredType", { message: "Mức chiết khấu" }),
      },
      {
        validator: (_, value) => {
          if (value === null || value === undefined || value === "") {
            return Promise.resolve();
          }

          if (!/^\d+(\.\d{1,2})?$/.test(String(value)) || Number(value) < 0 || Number(value) > 1) {
            return Promise.reject(new Error("Mức chiết khấu không hợp lệ, vui lòng xác nhận lại."));
          }

          return Promise.resolve();
        },
      },
    ],
  },
  inputOptions: {
    placeholder: "Nhập mức chiết khấu",
  },
};

const highlightField = {
  type: INPUT_TYPE.TEXT,
  formItemOptions: {
    label: <Typography.Text strong>Mô tả ngắn</Typography.Text>,
    name: "highlight",
    rules: [
      {
        required: true,
        message: t("common.messageRequiredType", { message: t("campaign.form.highlight") }),
      },
      { max: 300, message: t("campaign.form.descriptionOutOfLimit") },
    ],
  },
  inputOptions: {
    placeholder: "Nhập mô tả ngắn cho chương trình",
    rows: 3,
    disabled: true,
    style: { opacity: 0.7 },
  },
};

function CashDiscountInfo({ form }) {
  const onEditorChange = (value) => {
    form.setFieldsValue({ description: value });
  };

  return (
    <Card title={<Typography.Title level={5}>{t("campaign.form.marketingInfo")}</Typography.Title>}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <FormInput {...discountRateField} />
        </Col>
        <Col span={24}>
          <FormInput {...highlightField} />
        </Col>
        <Col span={24}>
          <Form.Item
            className="custom-markdown"
            label={<Typography.Text strong>Chi tiết thể lệ</Typography.Text>}
            name="description"
          >
            <QuillEditor onEditorChange={onEditorChange} canUpdateInfo={false} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}

export default CashDiscountInfo;
